export default __webpack_public_path__ + "static/media/oxygen-black.a1f11b2d.svg";